class MaxMainShapeTextHeightDirective {
    constructor($timeout, $rootScope) {
        this.restrict = 'A';
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
    }

    link($scope, elem, attrs, ngModel) {
        attrs.$set('ngTrim', 'false');

        elem.bind('keyup', function (e) {
            let maxValue = parseInt(attrs.maxValue);
            let value = parseInt(elem[0].value);
            const textLines = $scope.$parent.$ctrl.mainShape.text.split(/\r\n|\r|\n/).length;
            maxValue = Math.round(maxValue / textLines);

            if(value > maxValue) {
                elem[0].value = maxValue;
                $scope.$apply(function(){
                    console.log('!directive set maxValue', maxValue);
                    $scope.$parent.$ctrl.mainShape.h = maxValue;
                });
            }
        });
    }

    static directiveFactory($timeout, $rootScope) {
        'ngInject';
        return new MaxMainShapeTextHeightDirective($timeout, $rootScope);
    }
}

export default MaxMainShapeTextHeightDirective;
